export default __webpack_public_path__ + "static/media/symfony.b147dc8d.svg";